import { Route, Routes } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Category from "./pages/Category";
import Brands from "./pages/Brands";
import Product from "./pages/Product";
import Inventory from "./pages/Inventory";
import Sales from "./pages/Sales";
import Invoice from "./pages/Invoice";
import Draft from "./pages/Draft";
import CreateQuotation from "./pages/CreateQuotation";
import CreateInvoice from "./pages/CreateInvoice";

import SalesReturn from "./pages/SalesReturn";
import PurchaseReturn from "./pages/PurchaseReturn";
import Purchase from "./pages/Purchase";
import NewPurchaseForm from "./pages/NewPurchaseForm";
import NewPurchaseFormReturn from "./pages/NewPurchaseFormReturn";
import Reports from "./pages/Reports";
import User from "./pages/User";
import Customer from "./pages/Customer";
import NewSalesReturn from "./pages/NewSalesReturn";
import CustomerHistory from "./pages/CustomerHistory";
import CustomerHistoryDetails from "./pages/CustomerHistoryDetails";
import CreateDraft from "./pages/CreateDraft";
import Quotation from "./pages/Quotation";
import SaveInvoice from "./pages/SaveInvoice";
import Permission from "./components/auth/Permission";
import CompanySettings from "./pages/CompanySettings";
import AccountingList from "./pages/AccountingList";
import AccountingLanding from "./pages/AccountingLanding";
import EodBalance from "./pages/EodBalance";
import StaffManagement from "./pages/StaffManagement";
import Banking from "./pages/Banking";
import PosSettlement from "./pages/PosSettlement";
import VendorManagement from "./pages/VendorManagement";
import VendorDetail from "./pages/VendorDetail";
import Warranty from "./pages/Warranty";
import WarrantyDetail from "./pages/WarrantyDetail";
import WarrantyClaimForm from "./pages/WarrantyClaimForm";
import WarrantyClaimView from "./pages/WarrantyClaimView";
import DeadStockManagement from "./pages/DeadStockManagement";
//
import SessionManager from "./pages/SessionManager";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route index element={<Profile />} />
        <Route path="/category" element={<Category />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/product" element={<Product />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/company-settings" element={<CompanySettings />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/customer-history/:id" element={<CustomerHistory />} />
        <Route
          path="/customer-history/detail/:id"
          element={<CustomerHistoryDetails />}
        />
        {/* Only show /users route for admin */}
        <Route
          path="/users"
          element={
            <Permission roles={["ADMIN"]}>
              <User />
            </Permission>
          }
        />
        <Route path="/sales" element={<Sales />}>
          <Route index element={<Draft />} />
          <Route path="draft" element={<Draft />} />
          <Route path="quatation" element={<Quotation />} />
          <Route path="invoice" element={<Invoice />} />
        </Route>
        <Route path="/create-draft" element={<CreateDraft />} />
        <Route path="/create-quotation" element={<CreateQuotation />} />
        <Route path="/create-invoice" element={<CreateInvoice />} />

        <Route path="/save-invoice" element={<SaveInvoice />} />
        <Route path="/Purchase" element={<Purchase />} />
        <Route path="/create-invoice" element={<CreateInvoice />} />
        <Route path="/accounting-landing" element={<AccountingLanding />} />
        <Route path="/accounting-list" element={<AccountingList />} />
        <Route path="/accounting/eod" element={<EodBalance />} />
        <Route path="/staff-management" element={<StaffManagement />} />
        <Route
          path="/session-manager"
          element={
            <Permission roles={["ADMIN"]}>
              <SessionManager />
            </Permission>
          }
        />
        <Route path="/banking" element={<Banking />} />
        <Route path="/pos-settlement" element={<PosSettlement />} />
        <Route path="/vendor-management" element={<VendorManagement />} />
        <Route path="/vendor-management/:id" element={<VendorDetail />} />
        <Route path="/warranty" element={<Warranty />} />
        <Route
          path="/dead-stock-management"
          element={<DeadStockManagement />}
        />
        <Route path="/warranty/:salesId" element={<WarrantyDetail />} />
        <Route
          path="/warranty/:salesId/claim/:salesProductId/new"
          element={<WarrantyClaimForm mode="create" />}
        />
        <Route
          path="/warranty/:salesId/claim/:claimId"
          element={<WarrantyClaimView />}
        />
        <Route
          path="/warranty/:salesId/claim/:claimId/edit"
          element={<WarrantyClaimForm mode="edit" />}
        />
        <Route path="/sales" element={<Sales />} />
        <Route path="/sales-return" element={<SalesReturn />} />
        <Route path="/purchase-return" element={<PurchaseReturn />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/purchase/:id" element={<NewPurchaseForm />} />
        <Route path="/purchase/:id" element={<NewPurchaseForm />} />
        <Route path="/purchase/new" element={<NewPurchaseForm />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/sales-return/new" element={<NewSalesReturn />} />
        <Route path="/sales-return/:id" element={<NewSalesReturn />} />
        <Route
          path="/purchase-return/new"
          element={<NewPurchaseFormReturn />}
        />
        <Route
          path="/purchase-return/:id"
          element={<NewPurchaseFormReturn />}
        />
        <Route
          path="/purchase-return/edit/:id"
          element={<NewPurchaseFormReturn />}
        />
      </Route>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default App;
